import React, { useContext, useState } from 'react';
import { useUpdatePosteMutation } from '../../../services/SkillsManagement';
import { SnackBarContext } from '../../../Context/SnackBarContextProvider';
import EditIcon from '@mui/icons-material/Edit';
import { MenuItem, ListItemIcon, ListItemText, Grid } from '@mui/material';
import MuiDialog from '../../../SystemDesign/MuiDialog';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import FormInput from '../../../SystemDesign/FormInput';

const UpdatePoste = ({ row }) => {
    const [updatePoste] = useUpdatePosteMutation();
    const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);
    const [close, setClose] = useState(false);

    const initialValues = {
        name: row.original.name,
    };

    const [formValues, setFormValues] = useState(initialValues);

    const formValidationSchema = yup.object().shape({
        name: yup.string()
            .required("Position name is required")
            .min(3, "Position name must contain at least 3 characters"),
    });

    const handleSubmit = async (values, actions) => {
        try {
            const response = await updatePoste({ 
                posteId: row.original.posteId, 
                posteUpdateSchema: values 
            }).unwrap();
            
            setInfoAlert({ severity: 'success', message: `Position ${values.name} updated successfully`  });
            setOpenSnackBar(true);
            
            // Reset form and close dialog
            actions.resetForm();
            setFormValues(initialValues);
            setClose(true);
        } catch (error) {
            setInfoAlert({ severity: 'error', message: error.data?.message || 'An error occurred while updating the position' });
            setOpenSnackBar(true);
        }
        actions.setSubmitting(false);
    };

    return (
        <MuiDialog
            icon={<EditIcon />}
            triggerButton={
                <MenuItem>
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Edit</ListItemText>
                </MenuItem>
            }
            title="Update Position"
            subtitle={`Update position ${row.original.name}` }
            content={
                <Formik
                    initialValues={formValues}
                    validationSchema={formValidationSchema}
                    validateOnChange={false}
                    validateOnBlur={false}
                    enableReinitialize={true}
                    onSubmit={(values, actions) => {
                        handleSubmit(values, actions);
                    }}
                >
                    {(formik) => (
                        <Form id="updatePosteForm">
                            <Grid container spacing={2} marginTop={2}>
                                <Grid item xs={12}>
                                    <FormInput
                                        type="text"
                                        name="name"
                                        label="Position name"
                                        required={true}
                                        value={formik.values.name}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            setFormValues({ ...formValues, name: e.target.value });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            }
            existAction={true}
            actionTitle="Update"
            actionType="submit"
            formId="updatePosteForm"
            onClose={close}
        />
    );
};

export default UpdatePoste;
